module.exports = __webpack_public_path__ + "img/adaptive-learning.831a51af.svg";